import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiLinux,
  SiVisualstudiocode,
  SiJupyter,
  SiPostman,
  SiHeroku,
} from "react-icons/si";
import { CustomTooltip } from "../../components";

const tools = [
  { title: "Visual Studio", icon: <SiVisualstudiocode /> },
  { title: "Linux", icon: <SiLinux /> },
  { title: "Jupyter Notebook", icon: <SiJupyter /> },
  { title: "Postman", icon: <SiPostman /> },
  { title: "Heroku", icon: <SiHeroku /> },

]

const Toolstack = () => {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {tools.map((tool, i) => {
        return (<CustomTooltip key={i} title={tool.title}>
          <Col xs={4} md={2} className="tech-icons">
            {tool.icon}
          </Col>
        </CustomTooltip>)
      })}
    </Row>
  );
}

export default Toolstack;
